export const WorkspaceActivationStatus = {
  if: (el, s) => el.call('workspaceActivationView', s.root || s).visible,
  role: 'status',
  ariaLive: 'polite',
  ariaAtomic: true,
  position: 'fixed',
  right: 'B',
  bottom: 'B',
  zIndex: 9990101,
  width: 'G2',
  maxWidth: '90vw',
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  // A THEME name in a COLOUR slot paints NOTHING. `common-box` is registered
  // in designSystem/theme.js, never in color.js, so scratch's
  // `resolveMissingColor` passed the bare word through untouched (it must —
  // `currentColor` and `borderStyle: 'solid'` take the same route) and
  // css-in-props emitted the literal `background: common-box`. No parser
  // accepts that; every browser drops it and nothing warns. Measured 2026-09-22
  // on the real pipeline: `._bg-common-box {background: common-box;}` with
  // `getComputedStyle(...).backgroundColor === 'rgba(0, 0, 0, 0)'` — the banner
  // read as bare floating text on the page (Nika, my.symbols.app). `theme:` is
  // the slot that resolves this token, to `var(--theme-common-box-background)`.
  theme: 'common-box',
  color: 'title',
  borderRadius: 'radiusCard',
  // Same class of miss on the elevation: `float` is a SHADOW family name, and
  // the raw `boxShadow` slot resolves letter tokens against SPACING — it
  // emitted `box-shadow: var(--spacing-FLOAT)`, a custom property nothing
  // defines, so the plate had no lift either. `shadow:` is the design-system
  // prop and emits `var(--shadow-float)`.
  shadow: 'float',
  '@mobileL': { left: 'Z', right: 'Z', bottom: 'Z', width: 'auto', maxWidth: 'none' },

  Title: {
    fontSize: 'Z2',
    fontWeight: '700',
    text: (el, s) => {
      const view = el.call('workspaceActivationView', s.root || s)
      return view.titleKey ? el.call('polyglot', view.titleKey) : ''
    }
  },
  Text: {
    fontSize: 'Z',
    color: 'inactive',
    text: (el, s) => {
      const view = el.call('workspaceActivationView', s.root || s)
      if (!view.bodyKey) return ''
      return el
        .call('polyglot', view.bodyKey)
        .replace('{loaded}', String(view.values.loaded))
        .replace('{total}', String(view.values.total))
        .replace('{blocked}', String(view.values.blocked || ''))
    }
  },
  Button: {
    // A blocked verdict is settled — the payload arrived and the shell refused
    // it on content grounds. Offering Retry there promises an outcome no retry
    // can deliver, so the button is not rendered at all.
    if: (el, s) => el.call('workspaceActivationView', s.root || s).retryable,
    type: 'button',
    theme: 'primary',
    minHeight: 'controlH',
    borderRadius: 'radiusPill',
    alignSelf: 'flex-start',
    disabled: (el, s) => el.call('workspaceActivationView', s.root || s).busy,
    text: (el, s) =>
      el.call(
        'polyglot',
        el.call('workspaceActivationView', s.root || s).busy
          ? 'workspace.activation.retrying'
          : 'workspace.activation.retry'
      ),
    onClick: (event, el) => el.call('retryWorkspaceActivation')
  }
}
